import { EdgeTypes, MarkerType, type Edge } from "@xyflow/react";
import ElkSmoothStepEdge from "~/components/Playground/Edge/ElkSmoothStepEdge";
import { EdgeType } from "~/lib/pipeline/graph/EdgeType";
import { EdgeData } from "~/lib/pipeline";

export const edgeTypes: EdgeTypes = {
  [EdgeType.ExplicitDependency]: ElkSmoothStepEdge,
  [EdgeType.ImplicitDependency]: ElkSmoothStepEdge,
};

export function themeEdge(edge: Edge<EdgeData>): Edge<EdgeData> {
  const color = colorForEdge(edge);
  const zIndex = zIndexForEdge(edge);

  return {
    ...edge,
    className: "!pointer-events-none",
    zIndex,
    style: {
      stroke: color,
      strokeWidth: edge.selected ? 4 : 1.5,
    },
    markerEnd: {
      type: MarkerType.Arrow,
      color,
      height: edge.selected ? 6 : 16,
      width: edge.selected ? 6 : 16,
      strokeWidth: 1,
    },
  };
}

/**
 * Elevate edges based on their selection state and whether they are within a group step.
 *
 * Note: We **don't** return a default zIndex since defining it will cause ReactFlow to render
 * a wrapper around the edge, and can subsequently cause issues when rendering 1000+ edges.
 */
function zIndexForEdge(edge: Edge<EdgeData>): number | undefined {
  // Elevate selected edges above all other edges.
  if (edge.selected) {
    return 1002;
  }

  // Elevate edge above nodes to ensure they're always visible within groups steps.
  return edge.data?.sourceParentId || edge.data?.targetParentId ? 1001 : undefined;
}

function colorForEdge(edge: Edge<EdgeData>): string {
  if (edge.selected) {
    return "#086DD7";
  }

  return "#c2cace";
}
